import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './rootReducer';

import storageSession from 'redux-persist/lib/storage/session';
import { encryptTransform } from 'redux-persist-transform-encrypt';

const persistConfig = {
    key: 'root',
    storage: storageSession,
    transforms: [
        encryptTransform({ secretKey: process.env.REACT_APP_SECRET_KAY }),
    ],
};

// const persistConfig = {
//     key: 'root',
//     storage,
//     whitelist: ['reduxMaster'], // ✅ NOW THIS WORKS
// };

const persistedReducer = persistReducer(
    persistConfig,
    rootReducer
);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export const persistor = persistStore(store);
